import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useStockScans } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { scanActionLabel } from "../../../helpers/enum-labels";

interface IProps {
  stockUnitId: number;
}

export const StockScansList: React.FC<IProps> = ({ stockUnitId }) => {
  const { data, loading } = useStockScans({ where: { stockUnitId } });

  if (loading) return <Loading />;

  if (!data?.stockScans?.results?.length) {
    return <EmptyList text="Aucun scan enregistré" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Action</TableCell>
          <TableCell header>Par</TableCell>
          <TableCell header>Date</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.stockScans?.results?.map((scan) => (
          <TableRow key={`stock-scan-${scan.id}`} hover={false}>
            <TableCell>{scanActionLabel(scan.action)}</TableCell>
            <TableCell>
              {scan.scannedBy?.firstname} {scan.scannedBy?.lastname}
            </TableCell>
            <TableCell>{formatDisplayDate(scan.createdAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
